import { IDropdownResponse } from './util';
export interface IPendingContract {
  buildId: number;
  buildCreated: string;
  contractStarted: string;
  contractCompleted: string;
  neighborhoodName: string;
  plan: string;
  lotNumber: number;
  status: string;
  contractName: string;
  notes: string;
}

export interface IPendingContractsRes {
  records: IPendingContract[];
  totalRecordCount: number;
}

export interface IContractDetails {
  status: string;
  statusText: string;
  jobHasBeenPlatted: boolean;
  contractName: string;
  clientPhone: string;
  clientEmail: string;
  jobId: number;
  jobCode: string;
  neighborhoodPhaseLot: string;
  closingInviteSent: boolean;
  celebrationInviteSent: boolean;
  orientationInviteSent: boolean;
}

export interface IContractApprovedDetails {
  contractPrice: number;
  previousOffers: IPreviousOffers[];
  offerPrice: number;
  possibleLotFitIssuesText: string;
}

export interface IPreviousOffers {
  offerDate: string;
  clientOffer: number;
  counterOffer: number;
  notes: string;
}

export interface IContractTenDayCompleteDetails {
  acceptedClientOffer: number;
  upgradeCapOverage: number;
  appraisalAlarmValue: number;
  acceptedOfferDate: string;
  contractedAcceptedAmount: string;
  financingType: string;
  lenderStatus: string;
  tenDayUpgradeAmount: string;
  totalPriceFC: string;
  totalPriceFF2: string;
}

export interface IUnderContract {
  address: string;
  buildId: number;
  clientName: string;
  lenderContactName: string;
  lenderName?: string;
  loanType: string;
  lot: number;
  neighborhoodName: string;
  phase: string;
  sageId: string;
  superintendent?: string;
  estimatedClosingDate: string;
  closingAppointmentStart: string;
  closingAppointmentEnd: string;
  homeownerOrientation: string;
  homeownerCelebration: string;
  closingNotes: string;
  isClosingAppointmentAllDay: boolean;
  buildStatusName?: string;
}

export interface ICompleteBuildPayload {
  financingType: string;
  lenderId?: number | string;
}

export interface IContractDatesValues {
  estimatedCompletionDate?: string;
  sageClosingDate?: string;
  closingDateLocked?: boolean;
  closingAppointmentEnd?: string;
  closingAppointmentStart?: string;
  closingNotes?: string;
  lenderContactName?: string;
  lenderName?: string;
  homeownerCelebration?: string;
  homeownerCelebrationEnd?: string;
  homeownerOrientation?: string;
  homeownerOrientationEnd?: string;
  sentDocs?: boolean;
  sentDocsOn?: string;
  sentDocsBy?: string;
  thirtyDayEmail?: boolean;
  thirtyDayEmailOn?: string;
  thirtyDayEmailBy?: string;
  responseRecieved?: boolean;
  responseInfo?: string;
  isClosingAppointmentAllDay?: boolean;
}

export interface IContractDatesPayload {
  closingAppointmentStart: string;
  closingDateLocked: boolean;
  closingAppointmentEnd?: string;
  homeownerCelebration?: string;
  homeownerOrientation?: string;
  closingNotes: string;
  thirtyDayEmail: boolean;
  responseRecieved: boolean;
  responseInfo?: string;
  isClosingAppointmentAllDay?: boolean;
}

export interface IClientHistory {
  subject: string;
  sentDate: string;
  recipientDisplay: string;
  contactType: string;
  contactHistoryId: number;
}
export interface IUnderContractEmailPayload {
  emailTemplateId?: string;
  subject: string;
  emailAddresses: string[];
  message: string;
  location?: string;
  appointment?: string;
  eventType?: string;
}

export interface IAddressBookData {
  relationship: string;
  displayValues: string[];
}

export interface IAddressBookPayload {
  additionalContacts: string[];
  superintendentAccountName: string;
}

export interface IInvitationRes {
  address: string;
  buildId: string | number;
  clientName: string;
  lot: number;
  neighborhoodName: string;
  phase: string;
  location: string;
  buildEventId: number | null;
  invitationDetails: IInvitationDetails;
  body: string;
  subject: string;
}

export interface IInvitationDetails {
  subject: string | null;
  body: string | null;
  location: string;
  emailAddresses: string[];
  buildEventId: string | null;
}

export interface IFinalContractNotification {
  subject: string;
  recipients: string[];
  body: string;
}

export interface IFinalPriceContractNotification {
  subject: string;
  body: string;
  buildId: number;
}

export interface IContractAcceptedNotification {
  subject: string;
  recipients: string[];
  body: string;
}

export enum AddressBookNotificationTypes {
  InitialContractNotification = 'InitialContractNotification',
  FinalSignedContractNotification = 'FinalSignedContractNotification',
  Orientation = 'Orientation',
  Celebration = 'Celebration',
  Closing = 'Closing'
}

export enum EmailType {
  FinalPriceContractNotification = 'FinalPriceContractNotification',
  FinalContractNotification = 'FinalContractNotification',
  Email = 'Email',
  Invite = 'Invite',
  ContractAccepted = 'ContractAccepted'
}

export enum EventType {
  FinalPriceContractNotification = 'FinalPriceContractNotification',
  FinalContractNotification = 'FinalContractNotification',
  HomeownerOrientation = 'HomeownerOrientation',
  HomeownerCelebration = 'HomeownerCelebration',
  ClosingAppointment = 'ClosingAppointment',
  ContractAccepted = 'ContractAccepted'
}

export enum BuildStatus {
  New = 'New',
  BuildApproved = 'BuildApproved',
  ContractAccepted = 'ContractAccepted',
  TenDayComplete = 'TenDayComplete',
  Closing = 'Closing',
  Test = 'Test'
}

export type IUnderContractDocument = {
  buildDocumentId: number;
  name: string;
  date?: Date;
  fileName?: string;
  buildDocumentTypeId: number;
};

export type IUnderContractDocumentResults = {
  buildDocuments: IUnderContractDocument[];
};

export enum DocumentContractingType {
  Unset = 'Unset',
  Scan = 'Scan',
  Digital = 'Digital'
}

export enum DocumentType {
  Contract = 'Contract',
  AddendumA = 'AddendumA',
  AddendumB = 'AddendumB',
  AddendumC = 'AddendumC',
  AddendumD = 'AddendumD',
  AddendumE = 'AddendumE',
  AddendumF = 'AddendumF',
  AddendumG = 'AddendumG',
  AddendumH = 'AddendumH',
  AddendumI = 'AddendumI',
  PlanSignOff = 'PlanSignOff',
  ContractOffer = 'ContractOffer',
  AcceptedContractOffer = 'AcceptedContractOffer',
  FinalContract = 'FinalContract',
  ClosingDocuments = 'ClosingDocuments',
  ElevationImage = 'ElevationImage',
  InteriorImage = 'InteriorImage',
  FinalImage = 'FinalImage',
  InsulationPhoto = 'InsulationPhoto'
}

export type IAddressBookItem = {
  group: string;
  items: IDropdownResponse[];
};

export type IEmailDetails = {
  body: string;
  sentBy: string;
  subject: string;
  sentDate: string;
  contactType: string;
  recipientDisplay: string;
  contactHistoryId: number;
};

export type IFileVersion = {
  buildDocumentVersionId: number;
  buildDocumentId: number;
  filename: string;
  uploadedDate: Date;
};

export interface ITenDayCompleteStatusDetails {
  acceptedClientOffer: number;
  upgradeCapOverage: number;
  appraisalAlarmValue: number;
  acceptedOfferDate: string;
  contractedAcceptedAmount: string;
  financingType: string;
  lenderStatus: string;
  tenDayUpgradeAmount: string;
  totalPriceFC: string;
  totalPriceFF2: string;
}

export type IContractDocumentResults = {
  generateRequired: boolean;
  regenerateRequired: boolean;
  hasCompletedContract: boolean;
  hasHouseContingencyWithoutAddendumK: boolean;
  contractDocuments: IContractDocument[];
  buildStatus: BuildStatus;
  salesContractingType: DocumentContractingType;
};

export type IContractDocument = {
  buildDocumentId: number;
  buildDocumentTypeId: BuildDocumentType;
  name: string;
};

export enum BuildDocumentType {
  Contract = 1,
  AddendumA = 2,
  AddendumB = 3,
  AddendumC = 4,
  AddendumD = 5,
  AddendumE = 6,
  PlanSignOff = 7,
  AddendumF = 8,
  ContractOffer = 9,
  AcceptedContractOffer = 10,
  FinalContract = 11,
  ClosingDocuments = 12,
  ElevationImage = 13,
  InteriorImage = 14,
  FinalImage = 15,
  InsulationPhoto = 16,
  AddendumG = 17,
  AddendumH = 18,
  AddendumI = 19,
  TabletReleaseForm = 20,
  BuyerAcknowledgementStatement = 21,
  AddendumJ = 22,
  AddendumK = 23,
  ContractPacket = 24,
  LenderLetter = 25,
  // Leave 26 empty for previous Deposit document type
  FinalPriceContract = 27
}

export interface ITodoItem {
  description: string;
  photoGuids: string[];
  dueDate: string;
  shouldSendCreationEmail: boolean;
}

export interface ITodoInfo {
  supervisor: string;
  punchlist: IPunchlistTodoInfo;
}

export interface IPunchlistTodoInfo {
  punchlistId: number;
  name: string;
  description: string;
}

export interface IDigitalContractDocument {
  buildDocumentId: number;
  buildDocumentType: string;
  fileDownloadName: string;
  lastModified: string;
  entityTag: string;
  enableRangeProcessing: boolean;
  file: any;
}
